export const industry_offer_content = {
    general: {
        brandOverviewFallback: 'Η Hellenic NLP Academy είναι ένας εκπαιδευτικός οργανισμός που ειδικεύεται στον Νευρο-Γλωσσικό Προγραμματισμό (NLP), προσφέροντας προγράμματα πιστοποίησης, σεμινάρια και ατομικό coaching. Στόχος του brand είναι η πρακτική ανάπτυξη προσωπικών και επαγγελματικών δεξιοτήτων, με έμφαση στην επικοινωνία, τη νοοτροπία και την επίτευξη στόχων. Απευθύνεται τόσο σε ιδιώτες όσο και σε επαγγελματίες που επιθυμούν ουσιαστική αυτοβελτίωση και εξέλιξη, μέσα από δομημένη εκπαίδευση και εφαρμόσιμα εργαλεία. Συνολικά, η Hellenic NLP Academy αποτελεί ένα σταθερό και αξιόπιστο εκπαιδευτικό brand προσωπικής ανάπτυξης, με ξεκάθαρη μεθοδολογία, εκπαιδευτική συνέπεια και έμφαση στη μεταφορά της γνώσης στην πράξη.',
        digitalChannels: {
            triggers: ['social_media_management', 'meta_ads', 'google_ads', 'email_marketing', 'tiktok_ads', 'blog', 'email_journey', 'profile_creation'],
            items: [
                'Facebook',
                'Instagram',
                'Meta Ads',
                'Google Ads',
                'Email Marketing'
            ]
        },
        socialManagement: {
            triggers: ['social_media_management'],
            items: [
                'Δημιουργία δημοσιεύσεων σε Facebook & Instagram.',
                '9 δημοσιεύσεις / 30 ημέρες βάσει προγράμματος.',
                'Το περιεχόμενο θα δημιουργείται απο επαγγελματικό φωτογραφικό υλικό και γραφιστικό υλικό.',
                'Τα κείμενα θα δημιουργούνται από τον Πάροχο κατόπιν σχετικής έρευνας στον κλάδο του Πελάτη.',
                'Ανάρτηση stories με το logo του Πελάτη και γραφιστικά κείμενα από διαθέσιμο φωτογραφικό υλικό.'
            ]
        },
        contentFlow: {
            triggers: ['social_media_management'],
            steps: [
                {
                    title: 'Παραγωγή ιδεών',
                    lines: [
                        'Εκπόνηση ιδεών επόμενης περιόδου.',
                        'Αποστολή αρχείου ιδεών στον Πελάτη.',
                        'Διορθώσεις και αναπροσαρμογή ιδεών.',
                        'Έγκριση ιδεών από Πελάτη.'
                    ]
                },
                {
                    title: 'Παραγωγή περιεχομένου',
                    lines: [
                        'Δημιουργία εικαστικών με βάση το αρχείο ιδεών.',
                        'Δημιουργία κειμένων με βάση το αρχείο ιδεών.',
                        'Αποστολή αρχείου περιεχομένου στον Πελάτη.',
                        'Διορθώσεις και έγκριση περιεχομένου επόμενης περιόδου.'
                    ]
                },
                {
                    title: 'Υλοποίηση πλάνου',
                    lines: [
                        'Ο Πάροχος εκτελεί όλες τις απαραίτητες ενέργειες ώστε να ακολουθήσει πιστά το εγκεκριμένο πλάνο.',
                        'Το πλάνο εκτελείται μέχρι το πέρας της περιόδου.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['meta_ads'],
                title: 'Meta Ads',
                items: [
                    'Διαμόρφωση Business Manager λογαριασμού και Payment Method.',
                    'Δημιουργία διαφημιστικού λογαριασμού και εγκατάσταση Meta Pixel.',
                    'Δημιουργία εκστρατειών σε Facebook & Instagram.',
                    'Προσαρμόζεται μετά το meeting που θα γίνει με τον marketing manager και την στρατηγική που θα ακουλουθήσουμε.',
                    'Περιοχή: Περιοχές κατόπιν συνεννόησης με τον Πελάτη.',
                    'Δημιουργία εκστρατειών επαναστόχευσης (remarketing).',
                    'Παρακολούθηση ROI και μηνιαία αναφορά.'
                ],
                recommendedBudget: '€200,00 / 30 ημέρες'
            },
            {
                serviceKeys: ['google_ads'],
                title: 'Google Ads',
                items: [
                    'Setup Google Analytics και Google Tag Manager.',
                    'Ενεργοποίηση και ρύθμιση Conversions.',
                    'Διαμόρφωση Google Ads account.',
                    'Δημιουργία εκστρατειών Performance Max και Search.',
                    'Χρήση λέξεων-κλειδιών για προσέγγιση κατάλληλου κοινού.',
                    'Περιοχή: Περιοχές κατόπιν συνεννόησης με τον Πελάτη.',
                    'Περιεχόμενο: Headlines & Descriptions με τα USP της επιχείρησης.'
                ],
                recommendedBudget: '€300,00 / 30 ημέρες'
            },
            {
                serviceKeys: ['tiktok_ads'],
                title: 'TikTok Ads',
                items: [
                    'Δημιουργία και βελτιστοποίηση TikTok Ads account.',
                    'Σχεδιασμός εκστρατειών με βάση το κοινό-στόχο και τα KPIs.',
                    'Προσαρμογή δημιουργικών ανά καμπάνια.',
                    'Παρακολούθηση αποτελεσμάτων και μηνιαία αναφορά απόδοσης.'
                ],
                recommendedBudget: '€600,00 / 30 ημέρες'
            },
            {
                serviceKeys: ['email_marketing'],
                title: 'Email Marketing',
                items: [
                    'Διαμόρφωση email πλατφόρμας για αυτοματοποιημένη αποστολή email.',
                    'Δημιουργία Welcome emails, Newsletter, Abandoned cart emails, Re-engagement emails.',
                    'Συνεχής βελτιστοποίηση με βάση KPIs (open rates, CTR, conversions).',
                    'Διαχείριση λίστας email και οργάνωση κοινού.',
                    'Δημιουργία περιεχομένου email.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo & Brandkit.',
            'Λειτουργική ιστοσελίδα.',
            'Πρόσβαση σε λογαριασμούς Google Ads, Analytics, Tag Manager.',
            'Πρόσβαση σε λογαριασμούς Meta (Business Manager, Pixel, Meta ad account).',
            'Παραχώρηση πρόσβασης διαχειριστή στα προφίλ Facebook & Instagram.',
            'Σαφής καθορισμός στόχων, υπηρεσιών και κοινού-στόχου.',
            'Φωτογραφικό υλικό για χρήση σε διαφημίσεις και social media.'
        ],
        assumptionsItems: [
            'Διαχείριση προφίλ επιχείρησης για ενεργή παρουσία στα social.',
            'Δημιουργία και βελτιστοποίηση Meta Campaigns.',
            'Δημιουργία και βελτιστοποίηση καμπανιών email marketing.',
            'Γενική επαναστόχευση επισκεπτών ιστοσελίδας και social engagement.',
            'Δημιουργία και διαχείριση διαφημιστικών εκστρατειών Google.',
            'Ρύθμιση conversion tracking και παρακολούθηση αποτελεσμάτων.',
            'Μηνιαία αναφορά απόδοσης με ανάλυση αποτελεσμάτων.'
        ],
        outOfScopeItems: [
            'Αλλαγές στη δομή ή τον σχεδιασμό της ιστοσελίδας.',
            'Διαχείριση και δημοσίευση σε άλλες κοινωνικές πλατφόρμες.'
        ],
        finalTerms: [
            {
                title: '1. Οικονομικοί Όροι',
                points: [
                    'a. Η προσφορά αφορά αποκλειστικά τη διαχείριση λογαριασμών ή/και διαφημίσεων και όχι τη διαφημιστική δαπάνη.',
                    'b. Η πληρωμή των υπηρεσιών γίνεται σύμφωνα με τον συμφωνημένο τιμοκατάλογο και τον κύκλο χρέωσης.',
                    'c. Σε μη έγκαιρη εξόφληση, ο Πάροχος μπορεί να διακόψει την παροχή υπηρεσιών μέχρι ολοκλήρωση πληρωμής.'
                ]
            },
            {
                title: '2. Ωράριο Εργασίας και Υποστήριξης',
                points: [
                    'a. Ωράριο Παρόχου: Δευτέρα έως Παρασκευή, 09:00-17:00 (GMT+2), εκτός αργιών.',
                    'b. Αιτήματα εκτός ωραρίου δρομολογούνται την επόμενη εργάσιμη ημέρα.'
                ]
            },
            {
                title: '3. Όροι Εμπιστευτικότητας',
                points: [
                    'a. Το περιεχόμενο της πρότασης είναι εμπιστευτικό και προορίζεται μόνο για τον Πελάτη και τους συνεργάτες του.',
                    'b. Πάροχος και Πελάτης διατηρούν εμπιστευτικές όλες τις πληροφορίες της συνεργασίας.'
                ]
            },
            {
                title: '4. Χρονοδιάγραμμα και Εκπλήρωση Υποχρεώσεων',
                points: [
                    'a. Οι εργασίες εκτελούνται με σειρά προτεραιότητας. Ελάχιστος χρόνος παράδοσης: μία εργάσιμη ημέρα.',
                    'b. Κάθε νέο βήμα ξεκινά μόνο μετά την ολοκλήρωση και έγκριση του προηγούμενου.',
                    'c. Ο Πάροχος δεν προχωρά έργο χωρίς ενεργή συνδρομή ή εξοφλημένες οικονομικές υποχρεώσεις.',
                    'd. Ο Πάροχος δεν φέρει ευθύνη για καθυστερήσεις από έλλειψη επικοινωνίας, καθυστέρηση εγκρίσεων, καθυστέρηση υλικού ή ανωτέρα βία.',
                    'e. Σε καθυστέρηση για άλλους λόγους, ο Πάροχος υποχρεούται να ενημερώσει τον Πελάτη.'
                ]
            },
            {
                title: '5. Πνευματικά Δικαιώματα και Ιδιοκτησία',
                points: [
                    'a. Η στρατηγική και οι διαφημιστικές εκστρατείες ανήκουν στον Πάροχο, εκτός αν συμφωνηθεί διαφορετικά εγγράφως.',
                    'b. Το παραγόμενο περιεχόμενο για λογαριασμό του Πελάτη μεταβιβάζεται στον Πελάτη με πλήρη εξόφληση.'
                ]
            },
            {
                title: '6. Έναρξη και Διάρκεια Συνεργασίας',
                points: [
                    'a. Η αποδοχή της προσφοράς ολοκληρώνεται με την καταβολή της συνδρομής.',
                    'b. Η συνδρομή ανανεώνεται αυτόματα κάθε 30 ημέρες, εκτός διαφορετικής συμφωνίας ή ακύρωσης.'
                ]
            },
            {
                title: '7. Λήξη και Τερματισμός Συνεργασίας',
                points: [
                    'a. Κάθε μέρος μπορεί να τερματίσει τη συμφωνία με γραπτή ειδοποίηση 30 ημερών.',
                    'b. Με τη λήξη, ο Πάροχος μπορεί να διαγράψει εκστρατείες, εκτός αν συμφωνηθεί διαφορετικά.',
                    'c. Οποιαδήποτε αλλαγή γίνεται μόνο εγγράφως και με αποδοχή και των δύο μερών.',
                    'd. Σε διαφωνία, τα μέρη επιδιώκουν φιλική επίλυση, διαφορετικά αρμόδια είναι τα δικαστήρια Βόλου.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Ευθύνη πληρωμής ανά κύκλο χρέωσης',
                lines: [
                    'Ο Πελάτης είναι υπεύθυνος να ολοκληρώνει έγκαιρα την πληρωμή κάθε κύκλου χρέωσης ώστε να παραμένουν ενεργές οι υπηρεσίες.'
                ]
            },
            {
                title: 'Αδυναμία ανανέωσης',
                lines: [
                    'Σε ανεπαρκές υπόλοιπο κάρτας γίνεται αυτόματη παύση συνδρομής και στη συνέχεια αυτόματη διακοπή.'
                ]
            },
            {
                title: 'Σύνδεσμος πληρωμής',
                lines: [
                    'Θα βρείτε το σύνδεσμο πληρωμής μαζί με αυτή τη προσφορά και ο/οι σύνδεσμοι ενεργοποίησης της προσφοράς παρατίθενται στην παρούσα προσφορά.'
                ]
            }
        ]
    },
    graphic: {
        brandOverviewFallback: 'Το project αφορά τη δημιουργία επαγγελματικού δημιουργικού υλικού για την προβολή της επιχείρησης σε ψηφιακά μέσα. Το παραδοτέο προσαρμόζεται στις ανάγκες του brand και αξιοποιείται σε social media, διαφημιστικά placements και υλικά επικοινωνίας.',
        digitalChannels: {
            triggers: ['profile_creation', 'social_media_creation'],
            items: [
                'Facebook',
                'Instagram'
            ]
        },
        socialManagement: {
            triggers: [],
            items: []
        },
        contentFlow: {
            triggers: ['video_edit', 'static_ad', 'logos', 'card', 'flyers_banners', 'catalog', 'profile_creation', 'social_media_creation', 'graphics'],
            steps: [
                {
                    title: 'Creative Brief',
                    lines: [
                        'Συλλογή στόχων, concept και βασικών απαιτήσεων του project.',
                        'Επιβεβαίωση format, διαστάσεων και χρήσης του δημιουργικού.'
                    ]
                },
                {
                    title: 'Παραγωγή δημιουργικού',
                    lines: [
                        'Σχεδιασμός/μοντάζ με βάση το συμφωνημένο brief.',
                        'Παράδοση πρώτης εκδοχής για έλεγχο.'
                    ]
                },
                {
                    title: 'Διορθώσεις και παράδοση',
                    lines: [
                        'Εφαρμογή διορθώσεων που έχουν συμφωνηθεί.',
                        'Τελική παράδοση αρχείων στα συμφωνημένα format.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['video_edit'],
                title: 'Video Edit',
                items: [
                    'Μοντάζ επαγγελματικού βίντεο για ψηφιακή χρήση.',
                    'Παράδοση σε format κατάλληλο για social media ή διαφημιστική χρήση.'
                ]
            },
            {
                serviceKeys: ['static_ad'],
                title: 'Static Ad',
                items: [
                    'Δημιουργία στατικού διαφημιστικού εικαστικού.',
                    'Εστίαση σε ξεκάθαρο μήνυμα και branded παρουσία.'
                ]
            },
            {
                serviceKeys: ['logos'],
                title: 'Logos',
                items: [
                    'Σχεδιασμός λογοτύπου με βάση την ταυτότητα του brand.',
                    'Παράδοση αρχείων σε format για ψηφιακή και έντυπη χρήση.'
                ]
            },
            {
                serviceKeys: ['card'],
                title: 'Card',
                items: [
                    'Σχεδιασμός επαγγελματικής κάρτας σύμφωνα με το brand style.',
                    'Παράδοση τελικού αρχείου για εκτύπωση.'
                ]
            },
            {
                serviceKeys: ['flyers_banners'],
                title: 'Flyers - Banners',
                items: [
                    'Σχεδιασμός flyer ή/και banner για προωθητική χρήση.',
                    'Προσαρμογή διαστάσεων ανά κανάλι προβολής.'
                ]
            },
            {
                serviceKeys: ['catalog'],
                title: 'Catalog',
                items: [
                    'Δημιουργία καταλόγου προϊόντων/υπηρεσιών σε επαγγελματική δομή.',
                    'Σχεδίαση με έμφαση στην παρουσίαση και την ευχρηστία.'
                ]
            },
            {
                serviceKeys: ['profile_creation', 'social_media_creation'],
                title: 'Social media profile creation',
                items: [
                    'Δημιουργία επαγγελματικής σελίδας Facebook.',
                    'Δημιουργία επαγγελματικού προφίλ Instagram.',
                    'Σύνδεση λογαριασμών για σωστή μελλοντική αξιοποίηση διαφημίσεων.'
                ]
            },
            {
                serviceKeys: ['graphics'],
                title: 'Graphics',
                items: [
                    'Custom γραφιστικό υλικό βάσει briefing και αναγκών project.',
                    'Η τελική κοστολόγηση καθορίζεται μετά την τελική περιγραφή.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo και Brand kit (αν υπάρχει).',
            'Βασικές πληροφορίες επιχείρησης.',
            'Κείμενα ή μηνύματα που πρέπει να συμπεριληφθούν.',
            'Φωτογραφικό υλικό ή προωθητικό υλικό (αν υπάρχει).',
            'Σαφής καθορισμός στόχων και κοινού-στόχου.'
        ],
        assumptionsItems: [
            'Formatted δημιουργικά για social media όπου απαιτείται.',
            'Στατική γραφιστική εικόνα με τις απαραίτητες πληροφορίες.',
            'Παράδοση τελικού δημιουργικού στα συμφωνημένα format.'
        ],
        outOfScopeItems: [
            'Ηχογράφηση ή δημιουργία voice-over.',
            'Διαχείριση περιεχομένου και posting (εκτός αν συμφωνηθεί ξεχωριστά).',
            'Δημιουργία και διαχείριση διαφημιστικών καμπανιών στη Meta ή αλλού.',
            'Δημιουργία πρωτότυπου video footage.'
        ],
        finalTerms: [
            {
                title: '1. Οικονομικοί Όροι',
                points: [
                    'a. Η υλοποίηση και παράδοση γίνεται μετά την επιβεβαίωση της πληρωμής σύμφωνα με την προσφορά.',
                    'b. Η παρούσα προσφορά αφορά one-off creative project.'
                ]
            },
            {
                title: '2. Ωράριο και Υποστήριξη',
                points: [
                    'a. Το τυπικό ωράριο εργασίας είναι Δευτέρα έως Παρασκευή, 09:00-17:00 (GMT+2), εκτός αργιών.',
                    'b. Αιτήματα εκτός ωραρίου δρομολογούνται την επόμενη εργάσιμη.'
                ]
            },
            {
                title: '3. Χρονοδιάγραμμα',
                points: [
                    'a. Η παραγωγή ξεκινά μετά την παραλαβή των προαπαιτούμενων υλικών.',
                    'b. Ο χρόνος παράδοσης επηρεάζεται από την ταχύτητα εγκρίσεων και διορθώσεων.'
                ]
            },
            {
                title: '4. Πνευματικά Δικαιώματα',
                points: [
                    'a. Τα πνευματικά δικαιώματα μεταβιβάζονται στον Πελάτη με την πλήρη εξόφληση του έργου.',
                    'b. Ο Πάροχος διατηρεί το δικαίωμα χρήσης του έργου ως portfolio, εκτός αν συμφωνηθεί διαφορετικά εγγράφως.'
                ]
            },
            {
                title: '5. Εμπιστευτικότητα',
                points: [
                    'a. Το περιεχόμενο της πρότασης είναι εμπιστευτικό και προορίζεται αποκλειστικά για τον Πελάτη.',
                    'b. Πάροχος και Πελάτης διατηρούν εμπιστευτικές τις πληροφορίες της συνεργασίας.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Τρόπος πληρωμής',
                lines: [
                    'Η πληρωμή του creative project γίνεται εφάπαξ.',
                    'Η ολοκλήρωση της διαδικασίας γίνεται με τραπεζική κατάθεση.'
                ]
            }
        ]
    },
    website: {
        brandOverviewFallback: 'Το project αφορά την υλοποίηση επαγγελματικής ιστοσελίδας με σαφές εμπορικό αποτύπωμα, σωστή δομή περιεχομένου και τεχνική υποστήριξη για σταθερή λειτουργία.',
        digitalChannels: {
            triggers: [],
            items: []
        },
        socialManagement: {
            triggers: [],
            items: []
        },
        contentFlow: {
            triggers: ['plan_starter', 'plan_business'],
            steps: [
                {
                    title: 'Discovery & Scope',
                    lines: [
                        'Καταγραφή στόχων, υπηρεσιών και βασικών λειτουργιών ιστοσελίδας.',
                        'Οριστικοποίηση δομής και απαιτούμενων σελίδων.'
                    ]
                },
                {
                    title: 'Design & Development',
                    lines: [
                        'Υλοποίηση responsive website με βάση το συμφωνημένο scope.',
                        'Ρύθμιση βασικών τεχνικών παραμέτρων και φόρμας επικοινωνίας.'
                    ]
                },
                {
                    title: 'Review & Launch',
                    lines: [
                        'Έλεγχος περιεχομένου, τελικές διορθώσεις και έγκριση.',
                        'Δημοσίευση της ιστοσελίδας σε production περιβάλλον.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['plan_starter'],
                title: 'Starter Website',
                items: [
                    'Δημιουργία WordPress ιστοσελίδας έως 5 σελίδες με προκαθορισμένη, επαγγελματική δομή.',
                    'Προσαρμογή εμφάνισης σε έτοιμο layout με εταιρικά χρώματα και έως 2 γραμματοσειρές.',
                    'Βασικό τεχνικό SEO setup (titles, meta descriptions, sitemap, indexing) και responsive προβολή.'
                ]
            },
            {
                serviceKeys: ['plan_business'],
                title: 'Business Website',
                items: [
                    'Δημιουργία WordPress ιστοσελίδας έως 15 σελίδες με custom δομή αρχικής σελίδας.',
                    'Πλήρης οπτική προσαρμογή (custom χρωματική παλέτα, έως 2 γραμματοσειρές, responsive προβολή).',
                    'Τεχνική υλοποίηση με βασική ασφάλεια, φόρμα επικοινωνίας, SEO-friendly δομή και νομικά templates.'
                ]
            },
            {
                serviceKeys: ['maintenance_starter'],
                title: 'Web Maintenance Starter',
                items: [
                    'Βασικός έλεγχος ασφάλειας με εγκατάσταση Wordfence και ειδοποιήσεις παραβίασης.',
                    'Διατήρηση αντιγράφου ασφαλείας με ανανέωση μία (1) φορά κάθε μήνα.',
                    'Επαναφορά ιστοτόπου σε περίπτωση hacking ή απώλειας, με ελάχιστη διατήρηση backup για 3 μήνες μετά τη λήξη.',
                    'Πάγια χρέωση πακέτου: €10,00 / 30 ημέρες (συμπεριλαμβάνει ΦΠΑ).'
                ]
            },
            {
                serviceKeys: ['maintenance_business'],
                title: 'Web Maintenance Business',
                items: [
                    'Περιλαμβάνει όλες τις παροχές του Starter maintenance.',
                    'Δωρεάν επιδιόρθωση σφαλμάτων που εμφανίζονται στην πλατφόρμα κατά τη διάρκεια της σύμβασης.',
                    'Έλεγχος και εγκατάσταση απαραίτητων ενημερώσεων WordPress και plugins μία (1) φορά κάθε μήνα.',
                    'Πάγια χρέωση πακέτου: €25,00 / 30 ημέρες (συμπεριλαμβάνει ΦΠΑ).'
                ]
            },
            {
                serviceKeys: ['maintenance_starter', 'maintenance_business'],
                title: 'Υπηρεσίες βελτίωσης και προτεραιότητες',
                items: [
                    'Αιτήματα βελτίωσης αποστέλλονται στο webdevelopment@doitforme.eu με κωδικό project DOWP και επίπεδο σοβαρότητας.',
                    'Αν δεν δηλωθεί σοβαρότητα, το αίτημα καταχωρείται αυτόματα ως Κανονική προτεραιότητα.',
                    'Άμεση προτεραιότητα: απόκριση εντός 1 εργάσιμης ημέρας και άμεση έναρξη ενεργειών υλοποίησης.',
                    'Άμεση προτεραιότητα: εβδομαδιαία αναφορά με άτομα, ώρες, ολοκληρωμένα μέρη και συνολικό κόστος βάσει ωριαίας χρέωσης.',
                    'Κανονική προτεραιότητα: απόκριση εντός 1 εργάσιμης ημέρας και προσφορά εντός 5 εργάσιμων ημερών από το αίτημα (ή τη συνάντηση αξιολόγησης).',
                    'Τιμοκατάλογος βελτιώσεων: Άμεση προτεραιότητα €30,00 / ώρα / άτομο (ελάχιστο κόστος €20,00). Κανονική προτεραιότητα: κόστος μετά από αξιολόγηση.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo και βασικό brand material.',
            'Τελικό περιεχόμενο (κείμενα/εικόνες) ή σαφές brief παραγωγής του.',
            'Πρόσβαση σε domain/hosting ή στοιχεία για νέα εγκατάσταση.',
            'Στοιχεία επικοινωνίας επιχείρησης και νομικά στοιχεία.'
        ],
        assumptionsItems: [
            'Η τελική δομή προσαρμόζεται στο επιλεγμένο πακέτο website.',
            'Η συντήρηση website αφορά τεχνικές εργασίες και όχι παραγωγή νέου project.',
            'Υπηρεσίες συντήρησης και βελτίωσης παρέχονται μόνο με ενεργό πακέτο υποστήριξης.',
            'Σε άμεση προτεραιότητα η τιμολόγηση γίνεται με βάση την πραγματική ωριαία απασχόληση.'
        ],
        outOfScopeItems: [
            'Custom integrations τρίτων συστημάτων που δεν έχουν συμφωνηθεί.',
            'Εκτεταμένο copywriting ή φωτογράφιση προϊόντων.',
            'Διαφημιστική διαχείριση καμπανιών.',
            'Εργασίες πέραν του συμφωνημένου πακέτου υποστήριξης χωρίς έγγραφη έγκριση.'
        ],
        finalTerms: [
            {
                title: '1. Οικονομικοί Όροι',
                points: [
                    'a. Το επιλεγμένο website πακέτο χρεώνεται εφάπαξ.',
                    'b. Οι υπηρεσίες συντήρησης και διαχείρισης χρεώνονται ανά 30 ημέρες μέσω Stripe, βάσει τιμοκαταλόγου ή συμφωνημένης προσφοράς.',
                    'c. Ο Πάροχος διατηρεί το δικαίωμα διακοπής εργασίας σε αίτημα άμεσης προτεραιότητας αν παρέλθει το χρονικό διάστημα εξόφλησης.',
                    'd. Ο Πάροχος δεν υποχρεούται να παραδώσει έργο κανονικής προτεραιότητας χωρίς πλήρη εξόφληση.',
                    'e. Εργασίες πέραν του συμφωνημένου πακέτου υποστήριξης χρεώνονται επιπλέον, κατόπιν έγγραφης ενημέρωσης και έγκρισης.'
                ]
            },
            {
                title: '2. Διαδικασία αιτημάτων βελτίωσης',
                points: [
                    'a. Τα αιτήματα βελτίωσης καταχωρούνται μέσω email και περιλαμβάνουν κωδικό project DOWP και επίπεδο σοβαρότητας.',
                    'b. Αίτημα χωρίς επίπεδο σοβαρότητας θεωρείται αυτόματα κανονικής προτεραιότητας.',
                    'c. Σε άμεση προτεραιότητα ο Πάροχος επιβεβαιώνει λήψη και έναρξη ενεργειών εντός μίας (1) εργάσιμης ημέρας.',
                    'd. Σε κανονική προτεραιότητα ο Πάροχος επιβεβαιώνει λήψη εντός μίας (1) εργάσιμης ημέρας και αποστέλλει προσφορά εντός πέντε (5) εργάσιμων ημερών από το αίτημα ή τη συνάντηση αξιολόγησης.'
                ]
            },
            {
                title: '3. Χρονοδιάγραμμα',
                points: [
                    'a. Η υλοποίηση ξεκινά με την επιβεβαίωση πληρωμής και την παραλαβή των προαπαιτούμενων.',
                    'b. Οι εργασίες βελτίωσης εκτελούνται με σειρά προτεραιότητας.',
                    'c. Ο χρόνος παράδοσης επηρεάζεται από εγκρίσεις και χρόνο απόκρισης του Πελάτη.'
                ]
            },
            {
                title: '4. Υποστήριξη',
                points: [
                    'a. Ωράριο υποστήριξης: Δευτέρα έως Παρασκευή, 09:00-17:00 (GMT+2), εκτός αργιών.',
                    'b. Αιτήματα εκτός ωραρίου εξυπηρετούνται την επόμενη εργάσιμη.'
                ]
            },
            {
                title: '5. Όροι εμπιστευτικότητας',
                points: [
                    'a. Το περιεχόμενο της πρότασης είναι εμπιστευτικό και προορίζεται αποκλειστικά για τον Πελάτη και τους συνεργάτες του.',
                    'b. Πάροχος και Πελάτης διατηρούν εμπιστευτικές τις πληροφορίες που αποκτώνται στη διάρκεια της συνεργασίας.'
                ]
            },
            {
                title: '6. Πνευματικά Δικαιώματα',
                points: [
                    'a. Με την πλήρη εξόφληση, το τελικό παραδοτέο μεταβιβάζεται στον Πελάτη.',
                    'b. Ο Πάροχος διατηρεί το δικαίωμα χρήσης του έργου ως portfolio, εκτός αν συμφωνηθεί διαφορετικά.'
                ]
            },
            {
                title: '7. Έναρξη και διάρκεια συνεργασίας',
                points: [
                    'a. Η συνεργασία ξεκινά με την αποδοχή της προσφοράς και την αντίστοιχη πρώτη πληρωμή.',
                    'b. Για πρόσβαση σε υπηρεσίες συντήρησης και βελτίωσης απαιτείται ενεργό πακέτο υποστήριξης.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Πληρωμές συντήρησης',
                lines: [
                    'Το web maintenance ενεργοποιείται μόνο μετά την επιβεβαίωση της αντίστοιχης επαναλαμβανόμενης πληρωμής.'
                ]
            },
            {
                title: 'Τιμοκατάλογος βελτιώσεων',
                lines: [
                    'Αιτήματα άμεσης προτεραιότητας: €30,00 / ώρα / άτομο (ελάχιστο κόστος €20,00).',
                    'Αιτήματα κανονικής προτεραιότητας: το κόστος διαμορφώνεται μετά από αξιολόγηση του αιτήματος.'
                ]
            }
        ]
    },
    education: {}
};
